import React from "react";

import { i18n } from "../../translate/i18n";
import ChatLayoutToggle from "../../components/ChatLayout/ChatLayoutToggle";
import ChatTicketsFilterPanel from "./ChatTicketsFilterPanel";
import * as TailwickChatIcons from "../../components/ChatLayout/tailwickChatIcons";
import { normalizeTicketCountBadge } from "../../helpers/ticketCountBadge";

function RailButton({ active, title, onClick, children, badge, compact }) {
	const { show, label } = normalizeTicketCountBadge(badge);

	return (
		<button
			type="button"
			className={`tailwick-chat-rail__btn${compact ? " tailwick-chat-rail__btn--compact" : ""}${
				active ? " tailwick-chat-rail__btn--active" : ""
			}`}
			onClick={onClick}
			title={title}
			aria-label={title}
		>
			{children}
			{show && (
				<span className="tailwick-chat-rail__badge">{label}</span>
			)}
		</button>
	);
}

/**
 * Filtros de tickets (aberto/pendente/fechado + filtros + layout).
 * variant="rail"  → coluna lateral (legado)
 * variant="inline" → toolbar no header da listagem
 */
export default function ChatTicketsFilterRail({
	tab,
	setTab,
	setTabOpen,
	openCount,
	pendingCount,
	statusPerfilEnabled = false,
	filterModalOpen,
	onFilterModalOpen,
	onFilterModalClose,
	onSort,
	sortOrder,
	user,
	selectedQueueIds,
	setSelectedQueueIds,
	selectedTagIds,
	setSelectedTagIds,
	tags,
	selectedChannels = [],
	setSelectedChannels,
	variant = "rail",
}) {
	const selectTab = (value) => {
		setTab(value);
		setTabOpen(value);
	};

	const defaultQueueIds = (user?.queues || []).map((queue) => queue.id);
	const hasQueueFilterActive =
		(selectedQueueIds?.length ?? 0) > 0 &&
		(selectedQueueIds.length !== defaultQueueIds.length ||
			!defaultQueueIds.every((id) => selectedQueueIds.includes(id)));

	const hasAdvancedFilters =
		hasQueueFilterActive ||
		(selectedTagIds?.length ?? 0) > 0 ||
		(selectedChannels?.length ?? 0) > 0;

	const compact = variant === "inline";

	const statusButtons = (
		<>
			<RailButton
				compact={compact}
				active={tab === "open"}
				title="Tickets abertos"
				badge={openCount}
				onClick={() => selectTab("open")}
			>
				<TailwickChatIcons.IconChatOpen />
			</RailButton>
			<RailButton
				compact={compact}
				active={tab === "pending"}
				title="Tickets pendentes"
				badge={pendingCount}
				onClick={() => selectTab("pending")}
			>
				<TailwickChatIcons.IconTicketsPending />
			</RailButton>
			{/* {statusPerfilEnabled ? (
				<RailButton
					compact={compact}
					active={tab === "status"}
					title="Status do WhatsApp"
					onClick={() => selectTab("status")}
				>
					<TailwickChatIcons.IconProfileStatus />
				</RailButton>
			) : null} */}
			<RailButton
				compact={compact}
				active={tab === "closed"}
				title="Tickets fechados"
				onClick={() => selectTab("closed")}
			>
				<TailwickChatIcons.IconTicketsClosed />
			</RailButton>
		</>
	);

	const filterButton = (
		<RailButton
			compact={compact}
			active={hasAdvancedFilters || filterModalOpen}
			title={i18n.t("chat.layout.filters")}
			onClick={onFilterModalOpen}
		>
			<TailwickChatIcons.IconFilters />
		</RailButton>
	);

	const filterPanel = (
		<ChatTicketsFilterPanel
			open={filterModalOpen}
			onClose={onFilterModalClose}
			tab={tab}
			sortOrder={sortOrder}
			onSort={onSort}
			userQueues={user?.queues}
			selectedQueueIds={selectedQueueIds}
			setSelectedQueueIds={setSelectedQueueIds}
			tags={tags}
			selectedTagIds={selectedTagIds}
			setSelectedTagIds={setSelectedTagIds}
			selectedChannels={selectedChannels}
			setSelectedChannels={setSelectedChannels}
		/>
	);

	if (variant === "inline") {
		return (
			<div className="tailwick-chat-rail tailwick-chat-rail--inline">
				<div className="tailwick-chat-rail__group" role="toolbar" aria-label="Status dos tickets">
					{statusButtons}
				</div>
				{filterPanel}
			</div>
		);
	}

	return (
		<div className="tailwick-chat-rail card-body flex h-full flex-col justify-between py-5 icon-side-bar">
			<div className="flex flex-col items-center gap-4 pt-4">
				{statusButtons}
				<div className="mt-2 flex flex-col items-center gap-2 border-t border-default-200 pt-4">
					{filterButton}
				</div>
				{filterPanel}
			</div>
			<div className="flex w-full flex-col items-center gap-3 border-t border-default-200 px-1 pb-2 pt-4">
				<ChatLayoutToggle useTailwickIcon />
			</div>
		</div>
	);
}
